/**
 * Shared exclude-index coercion for CSV prepare/emit and statement
 * reconciliation — one Set, one empty sentinel, no per-module copies.
 */

const EMPTY_EXCLUDE: ReadonlySet<number> = new Set();

/** Normalize optional exclude indexes to a ReadonlySet (arrays copied once). */
export function toCsvExcludeSet(
  indexes: ReadonlySet<number> | readonly number[] | undefined,
): ReadonlySet<number> {
  if (!indexes) return EMPTY_EXCLUDE;
  return indexes instanceof Set ? indexes : new Set(indexes);
}
